module.exports = __webpack_public_path__ + "static/media/w4.b499d7f9.svg";